<script setup>
import { computed, ref, watch } from 'vue'
import Calendar from 'primevue/calendar'
import { addDays, subDays } from 'date-fns'

const props = defineProps({
  userLicense: {
    type: Object,
    required: true
  }
})

const selectedLicense = ref(props.userLicense)
const licenseChoices = [
  {
    type: 'enterprise',
    sub_type: 'premium'
  },
  {
    type: 'individual',
    sub_type: 'trial'
  }
]
const selectedEndDate = ref(addDays(new Date(), 10))

function adjustEndDate(active) {
  if (active) {
    selectedEndDate.value = addDays(new Date(), 100)
  } else {
    selectedEndDate.value = subDays(new Date(), 10)
  }
}

const emit = defineEmits(['license:confirmEnabled', 'license:changed'])

const isDirty = computed(() => {
  return (
    selectedLicense.value.type !== props.userLicense.type ||
    selectedLicense.value.sub_type !== props.userLicense.sub_type
  )
})

const isConfirmEnabled = computed(() => {
  return (selectedLicense.value.type && isDirty.value) || false
})

watch(isConfirmEnabled, (newVal) => {
  emit('license:confirmEnabled', newVal)
})
watch([selectedEndDate, selectedLicense], () => {
  selectedLicense.value.end_date = selectedEndDate.value
  if (props.userLicense.start_date) {
    selectedLicense.value.start_date = props.userLicense.start_date
  } else {
    selectedLicense.value.start_date = subDays(new Date(), 100)
  }
  selectedLicense.value.uuid = 'is this real'
  emit('license:changed', selectedLicense.value)
})
</script>
<template>
  <div class="px-6">
    <p>Use this form to temporarily view pages with a different license.</p>
    <h4 class="pb-1 pt-2 font-medium">License Types:</h4>
    <div class="flex items-center" v-for="license in licenseChoices" :key="license.sub_type">
      <input
        type="radio"
        v-model="selectedLicense"
        :id="license.sub_type"
        :value="license"
        class="hover:cursor-pointer"
      />
      <label :for="license.sub_type" class="ml-2 text-md hover:cursor-pointer">{{
        license.type + ' ' + license.sub_type
      }}</label>
    </div>
    <h4 class="pb-1 pt-2 font-medium">License End Date:</h4>
    <div class="pb-3">
      <button
        class="border-gray-500 mr-2 rounded-md border p-1 text-sm"
        @click="adjustEndDate(false)"
      >
        Make Expired
      </button>
      <button class="border-gray-500 rounded-md border p-1 text-sm" @click="adjustEndDate(true)">
        Make Active
      </button>
    </div>
    <div class="card flex justify-center">
      <Calendar v-model="selectedEndDate" inline showButtonBar />
    </div>
  </div>
</template>
<style type="text/css"></style>
